export const MONITORING_STATUS = {
    initialize: 1,
    connect: 2,
    fail: 3,
    already_monitoring: 4,
    end: 5,
    offline: 6
}